/**
 * AssetOverview
 * 资产概览组件 - 账户信息总览
 *
 * @author page
 * @date 2026-04-25
 */
import React from 'react';
import type {SimulateAccount} from '../../types/simulate';

interface AssetOverviewProps {
    account: SimulateAccount;
}

const AssetOverview: React.FC<AssetOverviewProps> = ({account}) => {
    return (
        <div style={{padding: 8, height: '100%'}}>
            <div style={{display: 'grid', gridTemplateColumns: 'repeat(6, 1fr)', gap: 8}}>
                {[
                    {label: '初始余额', value: account.initialBalance},
                    {label: '可用余额', value: account.availableBalance, strong: true},
                    {label: '持仓价值', value: account.totalPositionValue || '0.00'},
                    {label: '冻结资金', value: account.frozenBalance || '0.00'},
                    {
                        label: '未实现盈亏',
                        value: account.unrealizedPnl || '0.00',
                        color: Number(account.unrealizedPnl || 0) >= 0 ? 'var(--pt-bull)' : 'var(--pt-bear)'
                    },
                    {label: '累计手续费', value: account.cumTradeFee || '0.00'},
                ].map(item => (
                    <div key={item.label} style={{
                        background: 'var(--pt-bg-panel)',
                        borderRadius: 4,
                        padding: '6px 10px',
                        border: '1px solid var(--pt-border-subtle)',
                    }}>
                        <div style={{
                            color: 'var(--pt-text-dim)',
                            fontSize: 10,
                            marginBottom: 2,
                            whiteSpace: 'nowrap',
                            fontFamily: "'IBM Plex Mono', Monaco, monospace",
                            letterSpacing: '0.3px'
                        }}>{item.label}</div>
                        <div style={{
                            color: (item as any).color || 'var(--pt-text-primary)',
                            fontSize: (item as any).strong ? 16 : 13,
                            fontWeight: (item as any).strong ? 600 : 500,
                            fontFamily: "'IBM Plex Mono', Monaco, monospace",
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                        }}>
                            {item.value}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default AssetOverview;
